// src/settingComponent/apiSetting/ApiBilling.jsx
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileAlt,
  faBookOpen,
  faProjectDiagram,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';
import { ApiEnabledContext } from '../ApiGlobalSettings';
import ApiInvoice from './ApiInvoice';
import ApiAddCredits from './ApiAddCredits';
import './ApiBilling.css';
import './ApiInvoice.css';

const ApiBilling = ({ creditDetails, invoices }) => {
  const isApiEnabled = useContext(ApiEnabledContext);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showAddCredits, setShowAddCredits] = useState(false);

  const openInvoice = () => setShowInvoice(true);
  const closeInvoice = () => setShowInvoice(false);

  const openAddCredits = () => setShowAddCredits(true);
  const closeAddCredits = () => setShowAddCredits(false);

  // compute dollar balance from credits
  const balance =
    creditDetails && typeof creditDetails.apiCredits === 'number'
      ? (creditDetails.apiCredits / 100).toFixed(2)
      : null;

  return (
    <>
      <div className="api-billing-container">
        <h1 className="api-billing-header">
          {isApiEnabled ? 'Pay as you go' : 'Resources'}
        </h1>

        {isApiEnabled && (
          <div className="api-credit-section">
            <div className="api-credit-label">
              Credit balance
            </div>
            <div className="api-balance-amount">
              {balance === null ? (
                <span className="balance-placeholder" />
              ) : (
                `$${balance}`
              )}
            </div>
            <div className="api-button-row">
              <button
                className="api-button api-add-button"
                onClick={openAddCredits}
              >
                Add to credit balance
              </button>
            </div>
          </div>
        )}
        <div className="api-sections">
          {/* API Documentation */}
          <a
            href="https://docs.bumpups.com/docs/getting-started"
            target="_blank"
            rel="noopener noreferrer"
            className="api-section-card"
            role="button"
            tabIndex="0"
            aria-label="API Documentation. Read the API getting started guide."
          >
            <div className="api-section-icon-wrapper">
              <FontAwesomeIcon icon={faBookOpen} className="api-section-icon" />
            </div>
            <div className="api-section-text">
              <div className="api-section-title">API Documentation</div>
              <div className="api-section-subtitle">
                Read the getting started guide
              </div>
            </div>
          </a>

          {/* Endpoints */}
          <a
            href="https://docs.bumpups.com/api-reference"
            target="_blank"
            rel="noopener noreferrer"
            className="api-section-card"
            role="button"
            tabIndex="0"
            aria-label="Endpoints. Browse the full API reference."
          >
            <div className="api-section-icon-wrapper">
              <FontAwesomeIcon
                icon={faProjectDiagram}
                className="api-section-icon"
              />
            </div>
            <div className="api-section-text">
              <div className="api-section-title">Endpoints</div>
              <div className="api-section-subtitle">
                Browse the full API reference
              </div>
            </div>
          </a>

          {/* Pricing */}
          <a
            href="https://docs.bumpups.com/docs/pricing"
            target="_blank"
            rel="noopener noreferrer"
            className="api-section-card"
            role="button"
            tabIndex="0"
            aria-label="Pricing. View API pricing details."
          >
            <div className="api-section-icon-wrapper">
              <FontAwesomeIcon icon={faDollarSign} className="api-section-icon" />
            </div>
            <div className="api-section-text">
              <div className="api-section-title">Pricing</div>
              <div className="api-section-subtitle">
                Cost to use API
              </div>
            </div>
          </a>

          {/* Billing history */}
          <div
            className={`api-section-card${!isApiEnabled ? ' disabled' : ''}`}
            role="button"
            tabIndex={isApiEnabled ? 0 : -1}
            aria-label="Billing history. View past and current invoices."
            onClick={isApiEnabled ? openInvoice : undefined}
          >
            <div className="api-section-icon-wrapper">
              <FontAwesomeIcon icon={faFileAlt} className="api-section-icon" />
            </div>
            <div className="api-section-text">
              <div className="api-section-title">Billing history</div>
              <div className="api-section-subtitle">
                View past and current invoices
              </div>
            </div>
          </div>
        </div>

        {/* New Terms & Policies line */}
        <p className="api-terms">
          By using our API, you agree to Bumpups’s{' '}
          <Link to="/api-terms-of-service">Terms of Service</Link> and{' '}
          <Link to="/api-privacy-policy">Privacy Policy</Link>.
        </p>

      </div>

      {showInvoice && <ApiInvoice invoices={invoices} onClose={closeInvoice} />} {/* Pass invoices */}
      {showAddCredits && <ApiAddCredits onClose={closeAddCredits} onAdd={() => { /* refresh credits */ }} />}
    </>
  );
};

export default ApiBilling;
